import web3 from 'web3';
import {parseForm} from "@jalik/form-parser";
import '../utils';
import __ from 'lodash';
import '../bootstrap';
import {initFlowbite} from "flowbite";

initFlowbite();

const form = document.querySelector('form[name="token"]');
const label = form?.querySelector('label[for="gateway-ethereum"]');
const loader = document.getElementById('loader');
const submit = form?.querySelector('button[type="submit"]');

window.addEventListener('load', () => {
    if (typeof window.ethereum === 'undefined' && label) {
        document.getElementById('desc-ethereum').textContent = __('MetaMask is not installed.').toString();
        label.classList.add('pointer-events-none', 'opacity-60');
    }
});

form?.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (form.querySelector('input[value="gateway-ethereum"]').checked) {

        const wallet = form.querySelector('input[name="wallet"]')?.value;

        if (!wallet) {
            messages({
                errors: true,
                message: __('Please check owner wallet address').toString(),
            });
            return;
        }

        try {

            loader.classList.remove('hidden');
            submit.classList.add('pointer-events-none', 'opacity-60');

            const sellerWallet = web3.utils.toChecksumAddress(wallet);
            const accounts = await ethereum.request({method: 'eth_requestAccounts'});
            const buyerWallet = accounts[0];

            // TODO: remove in production. Development mode only
            await ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{chainId: '0x13882'}],
            });

            const pricePol = form.querySelector('input[name="amount"]').value;
            const body = parseForm(form);
            const wei = BigInt(Math.floor(parseFloat(pricePol) * 1e18));

            body.txHash = await ethereum.request({
                method: 'eth_sendTransaction',
                params: [{
                    from: buyerWallet,
                    to: sellerWallet,
                    value: '0x' + wei.toString(16),
                }],
            });

            const response = await fetch(form.getAttribute('data-nft-action'), {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(body),
            });

            const data = await response.json();
            messages(data);

            if (response.ok) {
                setTimeout(() => window.location.reload(), 2000);
            }
        } catch (error) {
            if (error.code === -32002) {
                messages({
                    errors: true,
                    message: __('Confirm the pending MetaMask request').toString(),
                });
            }

            if (error?.code === 4001) {
                messages({
                    errors: true,
                    message: __('Transaction was cancelled by user').toString(),
                });
            } else {
                console.error(error);
                messages({
                    errors: true,
                    message: __('Transaction failed').toString(),
                });
            }
        } finally {
            loader.classList.add('hidden');
            submit.classList.remove('pointer-events-none', 'opacity-60');
        }
    } else {
        document.location.href = form.querySelector('input[type="radio"]:checked').dataset.gatewayAction;
    }
});
